import { Badge, severityVariant } from '@/shared/components/Badge'

interface Props {
  status: string
  critical?: number
  high?: number
  medium?: number
  low?: number
}

export function ScanStatusBadge({ status, critical = 0, high = 0, medium = 0, low = 0 }: Props) {
  if (status === 'published') {
    if (critical > 0) return <Badge variant={severityVariant('critical')}>{critical} critical</Badge>
    if (high > 0)     return <Badge variant={severityVariant('high')}>{high} high</Badge>
    if (medium > 0)   return <Badge variant={severityVariant('medium')}>{medium} medium</Badge>
    if (low > 0)      return <Badge variant={severityVariant('low')}>{low} low</Badge>
    return <Badge variant="green">✓ clean</Badge>
  }
  if (status === 'pending')    return <Badge variant="neutral">pending</Badge>
  if (status === 'processing') return <Badge variant="amber">scanning</Badge>
  if (status === 'failed')     return <Badge variant="neutral" style={{ color: 'var(--red)' }}>failed</Badge>
  return null
}
